




































import { Input } from '@/features/ui/inputs/model';
import { ArrayProp, BooleanProp, StringProp } from '@/util/prop-decorators';
import { differenceWith } from 'lodash';
import { Component, Model, Vue } from 'vue-property-decorator';
import { AttributeDefinition } from './model';
import query from './query.gql';
import {
  CoreInputAttributeDefinitionsSelectorQuery,
  CoreInputAttributeDefinitionsSelectorQueryVariables,
} from './__generated__/CoreInputAttributeDefinitionsSelectorQuery';
import { CustomerAdminRow, FormAttributeDefinition } from '@/features/app-customer/views/form/model';

@Component({
  apollo: {
    customers: {
      query,
      fetchPolicy: 'cache-and-network',
      variables(this: InputAttributeDefinitionsSelectorFilter): CoreInputAttributeDefinitionsSelectorQueryVariables {
        return { customerId: this.customerId, take: this.take };
      },
    },
  },
  data() {
    return { customers: undefined };
  },
})
export default class InputAttributeDefinitionsSelectorFilter extends Vue implements Input {
  @Model('update', { default: () => [] })
  @ArrayProp(() => [])
  private value!: FormAttributeDefinition[];

  private allAttributeDefinitions!: FormAttributeDefinition[];

  @StringProp(true)
  private readonly customerId!: string;

  @BooleanProp()
  private readonly order!: boolean;

  @BooleanProp()
  private readonly loadingPermittedUsers!: boolean;

  @ArrayProp(() => [])
  private readonly permittedUsers!: CustomerAdminRow[];

  private attributeDefinitionInput!: AttributeDefinition[];

  private readonly customers?: CoreInputAttributeDefinitionsSelectorQuery['customers'];

  private get selectedAttributeDefinitions(): FormAttributeDefinition[] {
    return this.value;
  }

  private get selectedPermittedUsers(): Omit<CustomerAdminRow, '__typename'>[] {
    return this.permittedUsers.map((user) => {
      const { __typename, ...rest } = user;
      return rest;
    });
  }

  private get attributeDefinitions(): FormAttributeDefinition[] {
    this.attributeDefinitionInput = this.customers?.first.attributeDefinitions.items ?? [];

    this.allAttributeDefinitions = this.attributeDefinitionInput?.map((item) => {
      return {
        __typename: 'FormAttributeDefinition',
        attributeDefinition: item,
        attributeDefinitionId: item.id,
        notesEnabled: false,
        notificationEnabled: false,
        notifyOnValues: [],
        notifyRecipients: null,
      };
    });

    return this.allAttributeDefinitions;
  }

  private get availableAttributeDefinitions(): FormAttributeDefinition[] {
    return differenceWith(
      this.attributeDefinitions,
      this.selectedAttributeDefinitions,
      (a, b) => a.attributeDefinitionId === b.attributeDefinitionId,
    );
  }

  private get take(): number {
    return 1000;
  }

  public get normalizedValue(): FormAttributeDefinition[] {
    return this.value;
  }

  public get empty(): boolean {
    return this.normalizedValue.length === 0;
  }

  public get pristine(): boolean {
    return true;
  }

  public removeAttributeDefinition(id: string): void {
    this.$emit(
      'update',
      this.value?.filter(({ attributeDefinitionId }) => attributeDefinitionId !== id),
    );
  }

  public addAttributeDefinition(formAttributeDefinition: FormAttributeDefinition): void {
    this.$emit('update', this.value.concat(formAttributeDefinition));
  }

  private getOptionLabel({ attributeDefinition }: FormAttributeDefinition): string {
    return attributeDefinition.configuration.description === null
      ? attributeDefinition.configuration.name
      : `${attributeDefinition.configuration.name} (${attributeDefinition.configuration.description})`;
  }

  private moveUp(index: number): void {
    const array = [...this.selectedAttributeDefinitions];
    [array[index], array[index - 1]] = [array[index - 1], array[index]];
    this.$emit('update', array);
  }

  private moveDown(index: number): void {
    const array = [...this.selectedAttributeDefinitions];
    [array[index], array[index + 1]] = [array[index + 1], array[index]];
    this.$emit('update', array);
  }

  private rowAltered(formAttributeDefinitions: FormAttributeDefinition[]): void {
    this.$emit('update', formAttributeDefinitions);
  }
}
